import { useMutation, useQueryClient } from 'react-query';
import { BrokerFixChannelSettingsService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
// eslint-disable-next-line camelcase
import type { Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_SetBrokerFixEngineDto } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { isFixEngineEnabledForBrokerQueryKey } from '../get/useGetIsFixEngineEnabledForBroker';
import { linkedCompaniesFixQueryKey } from '../get/useGetBrokerLinkedCompaniesFix';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';

export interface UsePostSetBrokerFixEngineEnabledProps {
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>;
}

/**
 * POST …/broker-fix-channel-settings/set-broker-fix-engine-enabled
 */
const usePostSetBrokerFixEngineEnabled = ({
  handleRequest,
}: UsePostSetBrokerFixEngineEnabledProps) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (
      payload: Wealthlane_AwardSettlementService_Dtos_BrokerFixChannelSettings_SetBrokerFixEngineDto
    ) => {
      return await handleRequest(
        BrokerFixChannelSettingsService.postApiAwardSettlementApiAppBrokerFixChannelSettingsSetBrokerFixEngineEnabled(
          payload
        )
      );
    },
    {
      onSuccess: (_data, variables) => {
        const brokerCompanyId = variables.brokerCompanyId;
        void queryClient.invalidateQueries(['getFixConfigByBrokerCompany', brokerCompanyId]);
        void queryClient.invalidateQueries(isFixEngineEnabledForBrokerQueryKey(brokerCompanyId));
        void queryClient.invalidateQueries(linkedCompaniesFixQueryKey(brokerCompanyId));
        toast.success(<ToastComponent label='Success' message='Broker Fix Engine edited.' />);
      },
    }
  );
};

export default usePostSetBrokerFixEngineEnabled;
